import { create } from 'zustand';
import { Network } from '@apolloGenerated';
import { NetworkIconEnum } from '@shared/ui';

type NetworkType = Network | NetworkIconEnum;

export enum TabAssetCurrency {
  Asset = 'asset',
  usd = 'usd',
}

type CurrencyType = {
  isAsset: TabAssetCurrency;
  currencies: Record<string, string>;
  currentCurrency: NetworkType;
  graphCurrentCurrency: NetworkType;
  changeIsAsset(val: TabAssetCurrency): void;
  setCurrencies(val: Record<string, string>): void;
  changeCurrencyCurrent(val: NetworkType): void;
  onGraphChangeCurrency(val: NetworkType | NetworkIconEnum): void;
};

export const useCurrencyListStore = create<CurrencyType>()((set) => ({
  isAsset: TabAssetCurrency.Asset,
  currencies: {},
  currentCurrency: NetworkIconEnum.Usdt,
  graphCurrentCurrency: NetworkIconEnum.Usd,
  setCurrencies: (val) => set({ currencies: val }),
  changeIsAsset: (val) => set({ isAsset: val }),
  changeCurrencyCurrent: (val) => set({ currentCurrency: val }),
  onGraphChangeCurrency: (val) => set({ graphCurrentCurrency: val }),
}));
